module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_stylovyze__;